<template>
  <div class="mask">
    <div class="poster-content" id="poster">
      <div class="top">
        <!-- 用户信息 -->
        <div class="user-info">
          <img class="avatar" :src="data.head_img" alt="" />
          <div class="nickname">{{ data.truename }}</div>
          <img
            class="logo"
            src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/cna-ques-logo"
            alt=""
          />
        </div>
        <!-- 食物信息 -->
        <div class="food-container" v-if="data.base_data">
          <div class="f-title">
            <img
              class="icon"
              src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/8dd1401bff6c9145cc71e3a5d4c01e39.png"
              alt=""
            />
            <div class="text1"
              >TA的{{
                data.base_data.meal_list[curIndex].label
              }}精准饮食方案</div
            >
            <img
              class="line"
              src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/793f7dd1f9fd79be4363cb9831fea5ec.png"
              alt=""
            />
            <div class="text2">betterWE权威定制</div>
          </div>
          <div class="f-content">
            <div
              class="type-item"
              v-for="(item, index) in data.base_data.meal_list[curIndex]
                .food_list"
              :key="index"
              :style="{ background: colorData[item.name].color3 }"
            >
              <div class="t-title">{{ item.name + item.gram_number }}g</div>
              <div class="food-list">
                <div
                  class="food-item"
                  v-for="(item1, index1) in item.food_type_list"
                  :key="index1"
                >
                  <div class="food-image">
                    <img class="image" :src="item1.image_url" alt="" />
                    <img
                      class="super-flag"
                      v-if="item1.is_super"
                      src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/159a9ada5ca72d0571bd0c2464441200.png"
                      alt=""
                    />
                  </div>
                  <div class="name">{{ item1.name }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="f-title">
            <img
              class="icon"
              src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/27fc2e9207d984c9679a98e7555e5373.png"
              alt=""
            />
            <div class="text1">每日推荐摄入总量</div>
          </div>
          <!-- 每日推荐总量 -->
          <div class="c-i-content">
            <div class="c-i-left">
              <div class="type-list">
                <div
                  class="type-item"
                  v-for="(item, index) in data.base_data.calorificData"
                  :key="index"
                >
                  <div
                    class="item-line"
                    :style="{ background: item.itemStyle.color }"
                  ></div>
                  <div class="item-name">{{ item.name }}</div>
                  <img
                    class="item-dash"
                    src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/793f7dd1f9fd79be4363cb9831fea5ec.png"
                    alt=""
                  />
                  <div class="item-num">{{ item.value }}</div>
                  <div class="item-unit">g</div>
                </div>
              </div>
            </div>
            <div class="c-i-right">
              <CircleEcharts
                fontSize="15"
                :data="data.base_data.calorificData"
                :kcalNum="data.base_calorific"
              />
            </div>
          </div>
        </div>
        <!-- 营养师描述 -->
        <div class="coach-content">
          <div class=""
            >betterWE营养师团队<br />为用户名字段最长十字符提供饮食方案支持</div
          >
          <img
            class="image"
            src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/ba5412cb19e85175217562e6f5dec223.png"
            alt=""
          />
        </div>
      </div>
      <div class="bottom">
        <div class="b-left">
          <div>下载betterWE，计算每日摄入量</div>
          <div class="b-flex"
            ><span class="bold">生成你的精细化饮食方案</span
            ><span class="download"
              >扫码下载<span
                class="iconfont icon-xiangshangzhanhang"
              ></span></span
          ></div>
        </div>
        <img
          class="qrcode"
          src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/bettwewe_download_qrcode"
          alt=""
        />
      </div>
    </div>
  </div>
</template>
<script>
import { recommendTotalData, colorData } from '../data.js'
import DaiyTotal from './daily-total.vue'
import CircleEcharts from './circle.vue'
export default {
  components: {
    DaiyTotal,
    CircleEcharts
  },
  props: {
    data: {
      type: Object,
      default: () => {
        return {}
      }
    },
    curIndex: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      recommendTotalData: recommendTotalData,
      colorData: colorData
    }
  }
}
</script>
<style lang="scss" scoped>
.mask {
  background-color: rgba(0, 0, 0, 0.6);
}

.poster-content {
  width: 335px;
  margin: 56px auto auto;
  background: linear-gradient(rgb(223, 232, 255) 0%, rgb(250, 252, 255) 100%);
  border-radius: 6px;
  overflow: hidden;

  .top {
    padding: 12px 12px 20px;

    .user-info {
      display: flex;
      align-items: center;
      margin-bottom: 10px;

      .avatar {
        border-radius: 50%;
        overflow: hidden;
        width: 33px;
        height: 33px;
        box-sizing: border-box;
        border: 1px solid #fff;
        object-fit: cover;
        margin-right: 10px;
      }

      .nickname {
        flex: 1;
        flex-shrink: 0;
        overflow: hidden;
        margin-right: 10px;
        font-size: 14px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: rgba(0, 0, 0, 0.8);
        line-height: 20px;
      }

      .logo {
        width: 71px;
        height: 12px;
        object-fit: contain;
      }
    }

    .food-container {
      background: #ffffff;
      border-radius: 8px;
      padding: 12px 12px 16px;
      position: relative;
      margin-bottom: 25px;

      .f-title {
        display: flex;
        align-items: center;
        margin-bottom: 10px;
        .line {
          height: 2px;
          flex: 1;
          flex-shrink: 0;
          overflow: hidden;
          object-fit: cover;
        }
        .icon {
          width: 24px;
          height: 24px;
          margin-right: 6px;
        }

        .text1 {
          font-size: 14px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: rgba(0, 0, 0, 0.8);
          line-height: 20px;
        }

        .text2 {
          font-size: 10px;
          font-family: PingFangSC-Regular, PingFang SC;
          color: rgba(0, 0, 0, 0.6);
          line-height: 14px;
        }
      }

      .f-content {
        border-radius: 12px;
        overflow: hidden;
        margin-bottom: 12px;
        .type-item {
          display: flex;
          align-items: center;
          padding: 10px 0px;
          .t-title {
            text-indent: 12px;
            width: 86px;
            text-align: left;
            font-size: 12px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: rgba(0, 0, 0, 0.8);
            line-height: 16px;
            margin-bottom: 8px;
          }

          .food-list {
            flex: 1;
            flex-shrink: 0;
            .food-item {
              display: flex;
              align-items: center;
              margin-bottom: 6px;
              .food-image {
                position: relative;
                width: 32px;
                height: 32px;
                margin-right: 15px;

                .image {
                  width: 100%;
                  height: 100%;
                  border-radius: 4px;
                  overflow: hidden;
                }
                .super-flag {
                  position: absolute;
                  left: 0;
                  bottom: 0;
                  width: 32px;
                }
              }

              .name {
                text-align: center;
                font-size: 12px;
                font-family: PingFangSC-Regular, PingFang SC;
                color: rgba(0, 0, 0, 0.8);
                line-height: 16px;
              }
            }
            .food-item:last-child {
              margin-bottom: 0px;
            }
          }
        }
      }

      .c-i-content {
        background: linear-gradient(
          180deg,
          #fafafa 0%,
          rgba(229, 229, 229, 0.1) 100%
        );
        border-radius: 12px;
        padding: 12px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .c-i-left {
          width: 140px;

          .type-list {
            .type-item {
              display: flex;
              align-items: center;
              margin-bottom: 13px;

              .item-line {
                width: 3px;
                height: 14px;
                background-color: rgba(161, 219, 240, 1);
                margin-right: 10px;
              }

              .item-name {
                font-size: 11px;
                font-family: PingFangSC-Regular, PingFang SC;
                color: rgba(0, 0, 0, 0.8);
                line-height: 16px;
                margin-right: 2px;
              }

              .item-dash {
                flex: 1;
                flex-shrink: 0;
                overflow: hidden;
                height: 2px;
                object-fit: cover;
                margin-right: 3px;
              }

              .item-num {
                font-size: 16px;
                font-family: DINAlternate-Bold, DINAlternate;
                font-weight: bold;
                color: #333333;
                line-height: 22px;
                margin-right: 4px;
              }

              .item-unit {
                font-size: 11px;
                font-family: PingFangSC-Regular, PingFang SC;
                color: rgba(0, 0, 0, 0.8);
                line-height: 16px;
              }
            }

            .type-item:last-child {
              margin-bottom: 0;
            }
          }
        }

        .c-i-right {
          width: 82px;
          height: 82px;
        }
      }
    }

    .food-container::after {
      content: '';
      width: 0;
      height: 0;
      position: absolute;
      bottom: -11px;
      right: 40px;
      border-top: 12px solid #fff;
      border-left: 9px solid transparent;
      border-right: 9px solid transparent;
    }

    .coach-content {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 12px;
      font-family: AlibabaPuHuiTi-Medium, AlibabaPuHuiTi;
      font-weight: 600;
      color: #4a3d6b;
      line-height: 16px;

      .image {
        width: 56px;
        height: 40px;
        object-fit: contain;
        margin-left: 10px;
      }
    }
  }

  .bottom {
    background: #f1f1f1;
    display: flex;
    align-items: center;
    padding: 6px 16px 14px;

    .b-left {
      flex: 1;
      flex-shrink: 0;
      overflow: hidden;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: rgba(0, 0, 0, 0.8);
      line-height: 26px;

      .bold {
        font-weight: 600;
      }

      .b-flex {
        display: flex;
        align-items: center;

        .download {
          margin-left: 10px;
          height: 20px;
          background-color: rgb(225, 226, 255);
          padding: 0px 2px 0px 8px;
          border-radius: 10px;
          font-size: 12px;
          display: flex;
          align-items: center;
          font-size: 10px;
          color: rgba(0, 0, 0, 0.8);

          .iconfont {
            width: 20px;
            height: 20px;
            display: flex;
            font-size: 16px;
            color: rgb(98, 54, 255);
            align-items: center;
            justify-content: center;
            transform: rotate(90deg);
            transform-origin: center center;
          }
        }
      }
    }

    .qrcode {
      width: 48px;
      height: 48px;
      margin-left: 10px;
    }
  }
}
</style>
